// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3OsXH","row":"ProcedureTreatmentSummary_row__14WhU"};